import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CsImage from './CsImage';

function CsDescription() {
    const { t } = useTranslation('customerService');
    const project = useProject();
    return (
        <Fragment>
            <Column spacing={8} fullWidth>
                <Text size='xl' fontWeight='medium' color={colors.gray9}>
                    {t('greeting.hello')}<br/>
                    {t('greeting.welcome', { projectName: project?.name || '' })}
                </Text>
                <Text color={colors.gray7}>
                    {t('greeting.selectChannel')}
                </Text>
            </Column>
            <CsImage/>
        </Fragment>
    );
}

export default CsDescription;
